// /**
//  * Partner - edit
//  */

// React
import React, {useEffect, useState} from 'react';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllUsersRequestBuilder} from 'client-sdk/src/users/users';
import CommonRepository from 'client-sdk/src/Repository/common-repository';
import PartnersRepository from 'client-sdk/src/Repository/partners-repository';
// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';

import {
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccount,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiHomeOutline,
  mdiTextBoxSearchOutline,
  mdiClipboardAccountOutline,
  mdiAccountNetworkOutline,
  mdiAccountTieOutline,
  mdiCounter,
  mdiPostOutline,
} from '@mdi/js';

// Type
import {User} from '../../users/interfaces';
import handleError from '../../../utils/handleError';
import { uuidv4 } from '../../../utils/helpers';

type Props = {
  data: any;
  update: (body: any) => void;
  onClose: () => void;
};

type Inputs = {
  name: string;
  workField: string;
  phoneNumber: string;
  address: string;
  representative: string;
  representativePosition: string;
  ranking: string;
  marketer: string;
  zipCode: string;
  province: string;
  city: string;
  economicCode: string;
  companyName: string;
};

// const
const user = {
  id: 0,
  name: '',
  phoneNumber: '',
  emailAddress: '',
  role: 'NONE',
  status: 'REGISTERED',
} as User;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    textField: {
      // width: '25ch',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
    },
  })
);

export default function Edit(props: Props) {
  const classes = useStyles();

  const {register, handleSubmit, errors, setValue, control} = useForm<Inputs>();
  const [value, setUser] = React.useState<User>(user);
  const [adminId, setAdminId] = useState(0 as number | undefined | null);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState<User>(user);
  const [options, setOptions] = React.useState<User[]>([user]);
  const [citiesList, setCitiesList] = useState([]);
  const [provincesList, setProvincesList] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const loading = openAutocomplete && options.length === 0;
  const [sendByCo, setSendByCo] = useState(false);

  React.useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .id(props.data.adminId)
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const user = response.data as User;
      setCurrentUser(user);
      setUser(user);
    })();
    setAdminId(props.data.adminId);
    setSendByCo(props.data.isUsingPartnerAddress);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .params({
          'role.equals': 'PARTNER_ADMIN',
          'partnersId.specified': false,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const users = response.data as User[];
      if (active) {
        setOptions([...[currentUser], ...users]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getProvinces();
    getProfiles();
  }, []);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]); // eslint-disable-line react-hooks/exhaustive-deps

  const getProfiles = async () => {
    try {
      const response = await PartnersRepository.getAllProfiles({})
      setProfiles(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const onSubmit = (data: any) => {
    const {
      name,
      workField,
      phoneNumber,
      address,
      representative,
      representativePosition,
      ranking,
      profile,
      marketer,
      zipCode,
      province,
      city,
      economicCode,
      companyName,
      sepidarCode,
      registrationCode
    } = data;
    const {id, type, status} = props.data;
    props.update({
      name,
      workField: workField.length > 0 ? workField : null,
      phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
      address,
      representative: representative.length > 0 ? representative : null,
      representativePosition:
        representativePosition.length > 0 ? representativePosition : null,
      ranking: ranking.length > 0 ? ranking : null,
      marketer: marketer.length > 0 ? marketer : null,
      id,
      profileId: profile,
      sepidarCode: sepidarCode ? sepidarCode : null,
      registrationCode: registrationCode ? registrationCode : null,
      zipCode,
      r2PartnerId: !!props.data.r2PartnerId ? props.data.r2PartnerId  :  uuidv4(),
      province,
      city,
      economicCode,
      companyName,
      isUsingPartnerAddress: sendByCo,
      adminId,
      type,
      status,
    });
  };

  const getCities = async (provinceId: number) => {
    try {
      const response = await CommonRepository.getCities({
        payload: {'provinceId.equals': provinceId},
      });
      setCitiesList(response.data);
    } catch (err) {
      handleError(err);
    }
  };
  
  const getProvinces = async () => {
    try {
      const response = await CommonRepository.getProvinces({payload: {}});
      setProvincesList(response.data);
      if(props.data.province) {
        setValue('province', props.data.province)
        const provinceId = response.data.filter(el => el.name === props.data.province)[0].id
        props.data.city && setValue('city', props.data.city)
        getCities(provinceId)
      }
    } catch (err) {
      handleError(err);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-end">
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام شرکت(برند تجاری)"
                defaultValue={props.data?.name}
                inputRef={register({required: true})}
                error={errors.name && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="companyName"
                name="companyName"
                label="نام حقیقی/حقوقی"
                defaultValue={props.data?.companyName}
                inputRef={register({required: true})}
                error={errors.companyName && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                size={1}
                className={classes.icon}
                style={{transform: 'rotate(-90deg)'}}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره تماس"
                type="number"
                defaultValue={props.data?.phoneNumber}
                inputRef={register({
                  required: true,
                })}
                error={errors.phoneNumber && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiTextBoxSearchOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="work-field-lable">حوزه فعالیت</InputLabel>
                  <Select
                    native
                    name="workField"
                    fullWidth
                    labelId="work-field-lable"
                    id="work-field"
                    defaultValue={props.data?.workField}
                    inputRef={register}
                    error={errors.workField && true}
                  >
                    {['FMCG', 'INSTAGRAM', 'ECOMMERCE'].map(
                      (field: any, index: number) => (
                        <option value={field} key={index}>
                          {field}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="province"
                control={control}
                defaultValue=""
                rules={{required: true}}
                render={({value}) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={provincesList}
                    inputValue={value}
                    id="province"
                    onChange={(event: any, newValue: any) => {
                      setValue('city', '');
                      getCities(newValue?.id);
                      setValue('province', newValue?.name);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="استان"
                        onChange={e =>
                          setValue('province', e.target.value)
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error focused>
                {errors?.province && 'استان سفاش‌دهنده الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="city"
                control={control}
                defaultValue=""
                rules={{required: true}}
                render={({value}) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={citiesList}
                    inputValue={value}
                    id="city"
                    onChange={(event: any, newValue: any) => {
                      setValue('city', newValue?.name);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="شهر"
                        onChange={e =>
                          setValue('city', e.target.value)
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error focused>
                {errors?.city && 'شهر سفاش‌دهنده الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiAccount} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="آدرس"
                defaultValue={props.data?.address}
                inputRef={register({required: true})}
                error={errors.address && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="کدپستی شرکت"
                defaultValue={props.data?.zipCode}
                inputRef={register({required: sendByCo})}
                error={errors.zipCode && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="representative"
                name="representative"
                label="نماینده شرکت"
                defaultValue={props.data?.representative}
                inputRef={register({required: false})}
                error={errors.representative && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="representativePosition"
                name="representativePosition"
                label="سمت نماینده شرکت"
                defaultValue={props.data?.representativePosition}
                inputRef={register({required: false})}
                error={errors.representativePosition && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountNetworkOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="marketer"
                name="marketer"
                label="بازاریاب شرکت"
                defaultValue={props.data?.marketer}
                inputRef={register({required: false})}
                error={errors.marketer && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="economicCode"
                name="economicCode"
                label="شناسه اقتصادی"
                defaultValue={props.data?.economicCode}
                inputRef={register({
                  required: true,
                })}
                error={errors.economicCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCounter} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="ranking">{`رتبه‌بندی`}</InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="ranking"
                    id="rank"
                    name="ranking"
                    inputRef={register}
                    defaultValue={props.data?.ranking}
                    error={errors.ranking && true}
                  >
                    <option value={''}></option>
                    {['KEY_ACCOUNT', 'A', 'B'].map(
                      (rank: any, index: number) => (
                        <option value={rank} key={index}>
                          {rank}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountTieOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <Autocomplete
                open={openAutocomplete}
                onOpen={() => {
                  setOpenAutocomplete(true);
                }}
                onClose={() => {
                  setOpenAutocomplete(false);
                }}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                getOptionLabel={option => option.name}
                options={options}
                value={value}
                loading={loading}
                disableClearable
                onChange={(event: any, newValue: User) => {
                  setAdminId(newValue?.id || null);
                  setUser(newValue);
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="انتخاب مدیر مرکز"
                    inputRef={register({required: false})}
                    name="admin"
                    id="admin"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCounter} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <FormControl style={{width: '100%'}}>
                <FormControl style={{width: '100%'}}>
                  <InputLabel id="profile">{`پروفایل`}</InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="profile"
                    id="rank"
                    name="profile"
                    inputRef={register}
                    defaultValue={profiles.filter(el => el.id === props.data?.profileId)[0]}
                    error={errors.profile && true}
                  >
                    {profiles?.map(
                      (profile: any, index: number) => (
                        <option value={profile.id} key={index}>
                          {profile.name}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>
              </FormControl>
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="sepidarCode"
                name="sepidarCode"
                label="کد سپیدار"
                defaultValue={props?.data.sepidarCode}
                inputRef={register({
                  required: false,
                })}
                error={errors.sepidarCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPostOutline} size={1} className={classes.icon} />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="registrationCode"
                name="registrationCode"
                label="شماره ثبت"
                defaultValue={props?.data.registrationCode}
                inputRef={register({
                  required: false,
                })}
                error={errors.registrationCode && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountTieOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
              <Checkbox
                checked={sendByCo}
                onChange={e => {
                  setSendByCo(e.target.checked);
                }}
                color="secondary"
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
              <div>
                <span>بسته با آدرس شرکت خودم ارسال شود</span>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item container xs={8}>
          <Button
            fullWidth
            type="submit"
            size="large"
            data-cy="search"
            autoFocus
            variant="contained"
            color="secondary"
          >
            {`ویرایش شرکت`}
          </Button>
        </Grid>
        <Grid item container xs={4}>
          <Button
            fullWidth
            variant="contained"
            onClick={props.onClose}
            size="large"
            data-cy="search"
          >
            {`انصراف`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
